import { useState } from 'react';
import { useBrowserLayoutEffect } from './useBrowserLayoutEffect';

function getBreakpoint() {
  if (typeof window === 'undefined' || !window) {
    return 'xl';
  }

  switch (true) {
    case window.matchMedia('(min-width: 1240px)').matches:
      return 'xl';
    case window.matchMedia('(min-width: 992px)').matches:
      return 'lg';
    case window.matchMedia('(min-width: 768px)').matches:
      return 'md';
    case window.matchMedia('(min-width: 544px)').matches:
      return 'sm';
    default:
      return 'xs';
  }
}

export function useBreakpoint() {
  const currentBreakPoint = getBreakpoint();
  const [breakpoint, setBreakpoint] = useState(currentBreakPoint);

  useBrowserLayoutEffect(() => {
    function breakpoint() {
      setBreakpoint(getBreakpoint());
    }

    if (typeof window !== undefined) {
      window.addEventListener('resize', breakpoint);
      return () => window.removeEventListener('resize', breakpoint);
    }
  }, [setBreakpoint]);

  return breakpoint;
}
